import styles from './CatalogCard.module.css';
import { Link } from 'react-router-dom';

export const CatalogCard = ({ genre, img }) => {
	return (
		<Link to={`/catalog/genre?genre=${encodeURIComponent(genre)}`} className={styles.main}>
			<div>
				<img src={img} className={styles.cardImg} alt="cardImg" />
				<p>{genre}</p>
			</div>
		</Link>
	);
};